import $store from '../store'
import config from '@/config'

// Example POST method implementation:
const fetchApi = async (url = '', method = '', data = {}, headers = {}) => {
  return new Promise(async (resolve, reject) => {
    // let _csrf =
    if (url == '') {
      console.error('Cannot fetch without URL')
      return
    }
    method = method.toUpperCase()
    if (method == '') {
      method = 'GET'
    }
    if (method != 'GET' && method != 'POST' && method != 'PUT' && method != 'DELETE') {
      console.error('Invalid method, please use: GET, POST, PUT, DELETE ')
      return
    }
    try {
      let response
      if (method == 'GET') {
        response = await fetch(url, { method: method }).then(resp => {
          return resp.json()
        })
      }
      if (method == 'POST' || method == 'PUT' || method == 'DELETE') {
        if ($store.state.general.user.csrf) {
          data._csrf = $store.state.general.user.csrf
        }
        let accept = {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
        Object.assign(headers, accept)
        response = await fetch(url, {
          headers: headers,
          method: method,
          body: JSON.stringify(data)
        }).then(async resp => {
          let responseJson = await resp.json()
          responseJson.statusCode = resp.status
          return responseJson
        })
      }
      resolve(response)
    } catch (err) {
      reject(err)
    }
  })
}
const fetchGraph = async (query, type) => {
  return new Promise(async (resolve, reject) => {
    async function goGetEm(query) {
      const headers = {
        Authorization: `Bearer ${$store.state.general.user.jwt.jwtToken}`
      }
      const accept = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
      Object.assign(headers, accept)
      const method = 'POST'
      const data = {
        _csrf: $store.state.general.user.csrf,
        query: query,
        operationName: null,
        variables: {}
      }
      const response = await fetch(config.graphUrl, {
        headers: headers,
        method: method,
        body: JSON.stringify(data)
      }).then(resp => {
        return resp.json()
      })
      return response
    }
    try {
      let response
      switch (type) {
        case 'all':
          response = await goGetEm(query)
          break
        default:
          response = await goGetEm(query)
          break
      }

      resolve(response)
    } catch (err) {
      console.log(err)
      reject(err)
    }
  })
}
// const allGraph = ''
const isEmpty = obj => {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false
  }
  return true
}

export default { fetchApi, fetchGraph, isEmpty }
